import React from "react";
import ServiceHeader from "../ServiceHeader/ServiceHeader";
import aboutImg from "../../secondAssets/Images/about-img.png"
import aboutThreeImg from "../../secondAssets/Images/aboutthreeImg.webp"
import aboutNormalToothImg from "../../secondAssets/Images/aboutNormalTooth.webp"
import aboutTeethImg from "../../secondAssets/Images/aboutTeethImg.jpg"
import aboutTeeth2Img from "../../secondAssets/Images/aboutTeeth2Img.jpg"
import { IoMdMail } from "react-icons/io";

const AboutComponent = (props) => {
    const { selectedLanguage } = props;
    return (
        <div>
            <div className="about-component-main">
                <ServiceHeader serviceHeaderImg={aboutImg} serviceHeading={selectedLanguage?.txt_the_dental_and_oral_health_summit} serviceText={selectedLanguage?.txt_innovative_ideas_in_dentistry} />
                <div className="about-img-and-text-section">
                    <div data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <img src={aboutThreeImg} alt="" />
                    </div>
                    <div data-aos="fade-left"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <h2>{selectedLanguage?.txt_dental_health_current_research}</h2>
                        <p>{selectedLanguage?.txt_until_i_hate_it}</p>
                    </div>
                </div>
                <div className="about-img-and-text-section about-img-and-text-second-section">
                    <div data-aos="fade-left"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <img src={aboutNormalToothImg} alt="" />
                    </div>
                    <div data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <h2>{selectedLanguage?.txt_oral_hygiene_role_of_mouthwash}</h2>
                        <p>{selectedLanguage?.txt_until_i_hate_it}</p>
                    </div>
                </div>
            </div>
            <div className="about-second-component-main">
                <div className="about-dental-Implants-section">
                    <div data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <h1>{selectedLanguage?.txt_the} <span>{selectedLanguage?.txt_role_of_dental}</span> {selectedLanguage?.txt_implants}</h1>
                        <div>
                            <p>{selectedLanguage?.txt_at} <b>{selectedLanguage?.txt_young_night}</b> {selectedLanguage?.txt_glamor_day}</p>
                            <button>{selectedLanguage?.txt_purchase_theme}</button>
                        </div>
                    </div>
                    <div data-aos="fade-left"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <img src={aboutTeethImg} alt="" />
                    </div>
                </div>
                <div className="about-dental-Implants-section">
                    <div data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <img src={aboutTeeth2Img} alt="" />
                    </div>
                    <div data-aos="fade-left"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <h1><span>{selectedLanguage?.txt_implants}</span> {selectedLanguage?.txt_in_dentistry}</h1>
                        <div>
                        <p>{selectedLanguage?.txt_at} <b>{selectedLanguage?.txt_young_night}</b> {selectedLanguage?.txt_glamor_day}</p>
                            <button>{selectedLanguage?.txt_download_now}</button>
                        </div>
                        <p><i>{selectedLanguage?.txt_it_is_important_to_take_care}</i></p>
                    </div>
                </div>
            </div>
            <div className="about-bottom-section-main">
                <div className="about-bottom-section-main-overlay">
                    <h1
                        data-aos="fade-down"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">{selectedLanguage?.txt_get_the} <span>{selectedLanguage?.txt_latest_updates}</span> {selectedLanguage?.txt_from_us}</h1>
                    <p data-aos="fade-down"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">– {selectedLanguage?.txt_subscribe_to_our_newsletter} –</p>
                    <div data-aos="fade-down"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000" className='footer-inp-section about-input-div'>
                        <div>
                            <input type="email" placeholder={selectedLanguage?.footer_txt_email_id} />
                            <button><IoMdMail /></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutComponent